import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  const goTo = (id: string) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }), 300);
      return;
    }
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled ? 'bg-background/80 backdrop-blur-md border-b border-border' : ''
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="font-bebas text-2xl text-foreground tracking-wider">
          🌍 DUMBVERSE
        </Link>
        <div className="hidden md:flex items-center gap-8">
          <button onClick={() => goTo('feed')} className="text-muted-foreground hover:text-foreground text-sm font-mono transition-colors">
            The Feed
          </button>
          <Link to="/council" className="text-muted-foreground hover:text-foreground text-sm font-mono transition-colors">
            The Council
          </Link>
        </div>
        <button
          onClick={() => goTo('post')}
          className="bg-primary text-primary-foreground px-5 py-2 rounded font-bebas text-lg tracking-wide hover:bg-primary/90 transition-colors"
        >
          Post an Idea
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
